import { App } from "vue";
import { createVfm } from "vue-final-modal";

export function setupModal(app: App<Element>): void {
  const vfm = createVfm();
  app.use(vfm);
}
